import type { UseQueryResult } from '@tanstack/react-query';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import type { FilterRequest } from '~/shared/data-contract/filter';
import type { LearningOpportunitiesResponse } from '~/shared/data-contract/learning-opportunities';
import { learningOpportunitiesResponseSchema } from '~/shared/data-contract/learning-opportunities';

import { learningOpportunityKeys, learningOpportunityPathnames } from './query-keys';

export type LearningOpportunitiesFilterQueryResult = UseQueryResult<LearningOpportunitiesResponse>;

export const useLearningOpportunityFilterQuery = (
    { filter, paged = { page: 0, size: 20 }, sorted }: FilterRequest,
    enabled = true,
): LearningOpportunitiesFilterQueryResult => {
    const { validatingCobrainerApiFetcher } = useContext(ApplicationContext);

    return useQuery({
        enabled,
        placeholderData: keepPreviousData,
        queryFn: async () => {
            const result = await validatingCobrainerApiFetcher.postJson(learningOpportunitiesResponseSchema, {
                pathname: learningOpportunityPathnames.filter,
                payload: {
                    filter,
                    paged,
                    sorted,
                },
            });

            if (result.isOk) {
                return result.value;
            }

            throw result.error;
        },
        queryKey: [
            ...learningOpportunityKeys.filter(),
            'postJson',
            learningOpportunitiesResponseSchema,
            filter,
            paged,
            sorted,
        ],
        throwOnError: false,
    });
};
